import React from 'react'
import styled from 'styled-components'
import Button from 'components/Button'
import { Users, Plus } from 'lucide-react'

interface LocationPartnersEmptyStateProps {
	onAddPartner: () => void
}

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 3rem 1.5rem;
	text-align: center;
	background: #ffffff;
	border: 1px solid rgba(0, 0, 0, 0.08);
	border-radius: 12px;
	color: #2d3748;
	width: 100%;
`

const IconWrapper = styled.div`
	width: 96px;
	height: 96px;
	border-radius: 9999px;
	background: rgba(0, 128, 254, 0.08);
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 24px;

	svg {
		width: 48px;
		height: 48px;
		color: #0080fe;
	}
`

const Title = styled.h3`
	font-size: 1.375rem;
	font-weight: 700;
	margin-bottom: 0.5rem;
`

const Description = styled.p`
	max-width: 520px;
	margin: 0 auto 2rem;
	line-height: 1.6;
	color: #4a5568;
`

const Tip = styled.div`
	margin-top: 2rem;
	padding: 1rem 1.25rem;
	background: #f7fafc;
	border-radius: 12px;
	max-width: 440px;
	color: #4a5568;
	font-size: 0.95rem;

	h4 {
		margin: 0 0 0.5rem;
		font-size: 0.9rem;
		font-weight: 600;
		color: #2d3748;
	}
`

const LocationPartnersEmptyState: React.FC<LocationPartnersEmptyStateProps> = ({ onAddPartner }) => {
	return (
		<Container>
			<IconWrapper>
				<Users className="w-4 h-4" />
			</IconWrapper>
			<Title>No Partners Yet</Title>
			<Description>
				Invite partners to collaborate on this project. You can add internal teammates or external
				stakeholders to your deal team.
			</Description>

			<Button variant="primary" onClick={onAddPartner}>
				<>
					<Plus className="w-4 h-4" />
					<span>Add Partner</span>
				</>
			</Button>

			<Tip>
				<h4>💡 Tip</h4>
				<p>
					Partners receive an email invitation. You can resend the invitation at any time from the partner
					card menu.
				</p>
			</Tip>
		</Container>
	)
}

export default LocationPartnersEmptyState
